import React, { createContext, useState, useEffect, useContext } from "react";
import { usersService } from "../services";
import { showToast } from "../components";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";



const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [refreshToken, setRefreshToken] = useState(null);
  const [client, setClient] = useState(null);



  const login = async (userData) => {
    try {
      const token = await usersService.login(userData);
      setToken(token);
      const data = await usersService.getMe();
      setUser(data.user);
      setClient(data.client)
      showToast("success", "authentification avec succès");
      navigate("/liste-actifs");
    } catch (error) {
      showToast("warning", "Veuillez vérifier vos login/mot de passe");
    }
  };

  const login_emulator = async (userData) => {
    try {
      const token = await usersService.login_emulator(userData);
      setToken(token);
      const data = await usersService.getMe();
      setUser(data.user);
      setClient(data.client)
      showToast("success", "authentification avec succès");
      navigate("/liste-actifs");
    } catch (error) {
      showToast("warning", "Veuillez vérifier vos login/mot de passe");
    }
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    setClient(null);
    setRefreshToken(null);
  };
useEffect(() => {
  const storedToken = localStorage.getItem("token");
  const storedRefreshToken = localStorage.getItem("refresh_token");

  if (storedToken) {
    try {
      const decodedAccess = jwt_decode(storedToken);
      const currentTime = Date.now() / 1000;

      if (decodedAccess.exp <= currentTime) {
        if (storedRefreshToken) {
          const decodedRefresh = jwt_decode(storedRefreshToken);

          if (decodedRefresh.exp <= currentTime) {
            logout();
            return;
          }


          usersService
            .refresh() // ✅ FIX
            .then((data) => {
              setToken(data.access_token);
              setRefreshToken(data.refresh_token);
              return usersService.getMe();
            })
            .then((data) => {
              setUser(data.user);
              setClient(data.client);
            })
            .catch((err) => {
              console.error(err);
              logout();
            });
        } else {
          logout();
        }
      } else {
        setToken(storedToken);
        setRefreshToken(storedRefreshToken);

        usersService
          .getMe()
          .then((data) => {
            setUser(data.user);
            setClient(data.client);
          })
          .catch((error) => console.log(error));
      }
    } catch (error) {
      logout();
    }
  }
}, [navigate]);

  return (
    <UserContext.Provider
      value={{ user, client,login_emulator, login, logout, isAuthenticated: !!token && !!user, token }}
    >

      {children}
    </UserContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(UserContext);
}
